import { useEffect, useRef, useState } from 'react';

import { ReactComponent as SearchIcon } from 'assets/images/search.svg';

import styles from './styles.module.scss';
import { OutlinedInput } from '@mui/material';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';

type InputProps = {
  onChangeSearch: (newValue: string) => void;
} & OutlinedInputProps;

function SearchField({ value, onChangeSearch, ...props }: InputProps) {
  const timeoutRef = useRef<number | undefined>(undefined);

  const [search, _setSearch] = useState(value);

  function setSearch(val: string | number) {
    timeoutRef.current && clearTimeout(timeoutRef.current);

    const value = `${val}`;
    _setSearch(value);

    timeoutRef.current = setTimeout(
      () => onChangeSearch && onChangeSearch(value),
      300
    ) as unknown as number;
  }

  useEffect(() => {
    _setSearch(value);
  }, [value]);

  return (
    <OutlinedInput
      {...props}
      color="secondary"
      classes={{
        root: styles.inputWrapper,
        input: styles.input,
        notchedOutline: styles.fieldset,
        focused: styles.fieldset,
        error: styles.error,
      }}
      startAdornment={<SearchIcon />}
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
      }}
    />

    // <InputStyled
    //   className={styles.input}
    //   placeholder={placeholder}
    //   value={search}
    //   onChange={(e) => {
    //     setSearch(e.target.value);
    //   }}
    //   startAdornment={<SearchIcon />}
    // />
  );
}

export default SearchField;
